import { Column as RSColumn } from '@react-stately/table';
import { SpectrumColumnProps } from '@react-types/table';

export type ColumnProps<T> = Omit<SpectrumColumnProps<T>, 'showDivider'>;

// Override TS for Column to support NextUI specific props.
const Column = RSColumn as <T>(props: ColumnProps<T>) => React.JSX.Element;

export default Column;
